import { useState } from "react";
import { Bell, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const AlertButton = ({ criteria, label, className = "", variant = "solid", testid = "alert-subscribe" }) => {
  const { user } = useAuth();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (addr) => {
    setBusy(true);
    try {
      await api.post("/saved-searches", { email: addr, ...criteria });
      toast.success(t("alert.created"));
      setOpen(false);
      setEmail("");
    } catch {
      toast.error(t("alert.error"));
    } finally {
      setBusy(false);
    }
  };

  const onClick = () => {
    if (user && user.email) submit(user.email);
    else setOpen(true);
  };

  const base = variant === "outline"
    ? "border border-orange-500 text-orange-600 hover:bg-orange-50"
    : "bg-slate-900 text-white hover:bg-orange-600";

  return (
    <>
      <button onClick={onClick} data-testid={testid}
        className={`inline-flex items-center justify-center gap-2 h-12 px-5 font-bold text-sm uppercase tracking-wide transition-colors ${base} ${className}`}>
        <Bell className="w-4 h-4" /> {label || t("alert.subscribe")}
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="rounded-none" data-testid="alert-dialog">
          <DialogHeader>
            <DialogTitle>{t("alert.dialogTitle")}</DialogTitle>
            <DialogDescription>{t("alert.desc")}</DialogDescription>
          </DialogHeader>
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder={t("alert.placeholder")} className="rounded-none h-12" data-testid="alert-email-input" />
          <DialogFooter>
            <button
              onClick={() => (EMAIL_RE.test(email.trim()) ? submit(email.trim()) : toast.error(t("alert.emailRequired")))}
              disabled={busy}
              className="inline-flex items-center justify-center gap-2 bg-orange-600 hover:bg-orange-700 disabled:opacity-60 text-white px-6 py-3 text-sm font-bold uppercase tracking-wide transition-colors w-full"
              data-testid="alert-confirm">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Bell className="w-4 h-4" />} {t("alert.activate")}
            </button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AlertButton;
